// @flow
import * as React from 'react';
import { useFollowUpsQuery, useMissedAppsTagId } from '../../../../shared';
import { keycloak } from '@coverright/shared/keycloak';
import { FollowUps } from './follow-ups';
import { useParams } from 'react-router-dom';

export const MissedApps = () => {
  const missingAppsTagId = useMissedAppsTagId();
  const {agentId} = useParams<{ agentId?: string }>();

  if (!missingAppsTagId) {
    return null;
  }

  return (
    <FollowUps suffix={'MissedAppts'}
               title={'Missed Appointments'}
               includedTagsIds={[missingAppsTagId]}
               dataSource={useFollowUpsQuery}
               agent={agentId || keycloak?.tokenParsed?.sub} />
  );
};
